import Constants from 'expo-constants';

const { apiEndpoint, defaultTimeout } = Constants.expoConfig.extra.azure;

export default {
  apiEndpoint,
  defaultTimeout,
};
